var App = App || {};

App.Testimonials = (function ($) {
    "use strict";

    function init() {
        var $carouselSection = $("section.testimonials.carousel");

        if ($carouselSection.length) {
            $.each($carouselSection, function () {
                var $this = $(this),
                    $carousel = $this.find(".slides"),
                    $carouselControls = $this.find(".controls"),

                    $playButton = $this.find(".slick-play"),
                    $pauseButton = $this.find(".slick-pause");

                if ($carousel.length) {
                    $carousel.slick({
                        appendArrows: $carouselControls,
                        arrows: true,
                        autoplay: true,
                        autoplaySpeed: 7500,
                        infinite: true,
                        nextArrow: "<button class=\"slick-next slick-arrow\" aria-label=\"Next testimonial\" type=\"button\"><span class=\"fas fa-fw fa-angle-right\"></span></button>",
                        prevArrow: "<button class=\"slick-prev slick-arrow\" aria-label=\"Previous testimonial\" type=\"button\"><span class=\"fas fa-fw fa-angle-left\"></span></button>",
                        slidesToScroll: 1,
                        slidesToShow: 1
                    });

                    $playButton
                        .hide()
                        .on("click", function () {
                            $carousel.slick("slickPlay");

                            $playButton.hide();
                            $pauseButton.show();
                        });

                    $pauseButton.on("click", function () {
                        $carousel.slick("slickPause");

                        $pauseButton.hide();
                        $playButton.show();
                    });

                    if ($carousel.slick("getSlick").slideCount == 1) {
                        $carouselControls
                            .parent(".row")
                            .remove();
                    }
                }
            });
        }
    }

    return {
        init: init
    };
})(jQuery);

$(function () {
    App.Testimonials.init();
});